<template>
  <form method="post"
        :action="action"
        @submit.prevent="onSubmit"
        @keydown="form.errors.clear($event.target.name)">

    <div class="form-group my-input-item">
      <input type="text"
             name="name"
             class="form-control my-input-form my-input-form-grey"
             :placeholder="Lang.get('common.name')"
             v-model="form.name"
      >
      <span class="help is-danger text-danger"
            v-if="form.errors.has('name')"
            v-text="form.errors.get('name')">
            </span>
    </div>

    <div class="form-group my-input-item">
      <input type="text"
             name="phone"
             class="form-control my-input-form my-input-form-grey mobilephone-input-mask"
             :placeholder="Lang.get('common.phone')"
             v-model="form.phone"
      >
      <span class="help is-danger text-danger"
            v-if="form.errors.has('phone')"
            v-text="form.errors.get('phone')">
            </span>
    </div>
    <div class="form-group my-input-item position-relative">
      <select
          name="vacancy"
          class="form-control my-select-form my-input-form-grey"
          v-model="form.vacancy"
      >
        <option value="empty" selected>Выберите вакансию</option>

        <optgroup label="Офис"></optgroup>
        <option value="Специалист по планированию производства">Специалист по планированию производства</option>
        <option value="Юрисконсульт">Юрисконсульт</option>

        <optgroup label="Продажи"></optgroup>
        <option value="Маркетолог">Маркетолог</option>
        <option value="Продавец">Продавец</option>
        <option value="Руководитель службы маркетинга">Руководитель службы маркетинга</option>
        <option value="Управляющая делами магазина">Управляющая делами магазина</option>

        <optgroup label="Служба безопасности"></optgroup>
        <option value="Контролер КПП">Контролер  КПП</option>
        <option value="Контролер по движению готовой продукции">Контролер по движению готовой продукции</option>
        <option value="Охранник">Охранник</option>

        <optgroup label="Служба главного инженера"></optgroup>
        <option value="Мойщики оборудования и тары">Мойщики оборудования и тары</option>
        <option value="Слесарь-электрик по ремонту электрооборудования">Слесарь-электрик по ремонту электрооборудования</option>
        <option value="Подсобный рабочий">Подсобный рабочий</option>
        <option value="Электрогазосварщик">Электрогазосварщик</option>

        <optgroup label="Служба логистики"></optgroup>
        <option value="Водитель">Водитель</option>
        <option value="Инженер по безопасности движения">Инженер по безопасности движения</option>
        <option value="Слесарь по ремонту автомобилей">Слесарь по ремонту автомобилей</option>
        <option value="Экспедитор">Экспедитор</option>

        <optgroup label="Производство"></optgroup>
        <option value="Грузчик">Грузчик</option>
        <option value="Жиловщик мяса и субпродуктов">Жиловщик мяса и субпродуктов</option>
        <option value="Кладовщик">Кладовщик</option>
        <option value="Укладчик-упаковщик">Укладчик-упаковщик</option>
        <option value="Формовщик колбасной продукции">Формовщик колбасной продукции</option>


        <option value="else">Другая</option>
      </select>
      <div class="select-arrow"></div>
      <span class="help is-danger text-danger"
            v-if="form.errors.has('vacancy')"
            v-text="form.errors.get('vacancy')">
            </span>
    </div>
    <div class="form-group my-input-item" v-show="form.vacancy == 'else'">
      <input type="text"
             name="vacancy"
             class="form-control my-input-form my-input-form-grey"
             :placeholder="Lang.get('common.vacancy_other')"
             v-model="form.vacancy_other"
      >
      <span class="help is-danger text-danger"
            v-if="form.errors.has('vacancy_other')"
            v-text="form.errors.get('vacancy_other')">
            </span>
    </div>

    <div class="form-group my-input-item">
            <textarea name="message"
                      :placeholder="Lang.get('common.message')"
                      class="form-control my-input-form my-input-form-grey"
                      v-model="form.message">{{ form.message }}</textarea>
      <span class="help is-danger text-danger"
            v-if="form.errors.has('message')"
            v-text="form.errors.get('message')">
            </span>
    </div>

    <div class="form-check mb-2">
      <input class="form-check-input" type="checkbox" value="" id="agreeCheck" v-model="agree">
      <label class="form-check-label" for="agreeCheck">
        Я даю своё согласие на обработку персональных данных в соответствии с
        <a href="/politika-konfidentsialnosti" target="_blank" class="my-link"> Политикой конфиденциальности </a>
        и <a href="/soglasie-na-obrabotku-personalnykh-dannykh" target="_blank" class="my-link">Согласием на обработку персональных данных</a>.
      </label>
    </div>

    <input type="text"
           name="checkBot"
           v-model="checkBot"
    >

    <input class="my-button"
           type="submit"
           :disabled="isDisabled"
           :value="Lang.get('common.send')">
    <widget-loading v-if="form.loading" color="#03a9f4"></widget-loading>
  </form>
</template>

<script>
import WidgetLoading from '../elements/WidgetLoading';

export default {
  name: "form-vacancy",
  components: {
    WidgetLoading,
  },
  props: {
    vacancy: {required: false},
    category: {required: false},
  },
  data() {
    return {
      form: new Form({
        name: '',
        phone: '',
        vacancy: 'empty',
        vacancy_other: '',
        message: '',
        type: 'form_vacancy',
        url: location,
        lang: siteLang,
      }),
      action: '/vacancy',
      checkBot: '',
      Lang,
      agree: true,
    }
  },

  computed: {
    isDisabled() {
      return !this.agree || this.form.loading || this.form.errors.any();
    }
  },

  methods: {
    onSubmit() {
      if(this.checkBot === '') {
        this.form.submit(this.$el.method, this.$el.action).then(res => {
          this.$parent.$el.innerHTML = "<span class='success-sent-text text-center'>" + res + "</span>";
        }).catch(error => console.log(error));
      }
    },
  },
  mounted() {
    helpers.setInputMask('mobilephone');
    if(this.vacancy) {
      this.form.vacancy = this.vacancy;
    }
  }
}
</script>
